module.exports = __webpack_public_path__ + "img/photo-04.727c2582.png";